import { query } from "../../../erd-editor-schema/dist/query/index.js";
import { arrayHas } from "../../../utils/arrayHas.js";
import { createAction } from "../../../r-html/dist/store/index.js";
import { POSITION_REGISTER, SIZE_REGISTER, isOwnStep } from "../../geometryRegisters.js";
import { ActionType } from "./actions.js";
import { createMemo } from "../../../utils/collection/memo.entity.js";
import { round } from "es-toolkit/compat";
//#region src/engine/modules/memo/atom.actions.ts
var addMemoAction = createAction(ActionType.addMemo);
var addMemo = ({ doc, collections, lww }, { payload: { id, ui }, version }, { clock }) => {
	const safeVersion = version ?? clock.getVersion();
	query(collections).collection("memoEntities").addOne(createMemo({
		id,
		ui
	})).addOperator(lww, safeVersion, id, () => {
		if (!arrayHas(doc.memoIds)(id)) doc.memoIds.push(id);
	});
};
var moveMemoAction = createAction(ActionType.moveMemo);
var moveMemo = ({ collections, lww }, { payload: { ids, movementX, movementY }, version, tags }, context) => {
	const collection = query(collections).collection("memoEntities");
	for (const id of ids) collection.getOrCreate(id, (id) => createMemo({ id }));
	const step = (memo) => {
		memo.ui.x = round(memo.ui.x + movementX, 4);
		memo.ui.y = round(memo.ui.y + movementY, 4);
	};
	if (!isOwnStep(context, tags)) {
		collection.updateMany(ids, step);
		return;
	}
	const safeVersion = version ?? context.clock.getVersion();
	for (const id of ids) collection.replaceOperator(lww, safeVersion, id, POSITION_REGISTER, () => {
		collection.updateOne(id, step);
	});
};
var moveToMemoAction = createAction(ActionType.moveToMemo);
var moveToMemo = ({ collections, lww }, { payload: { id, x, y }, version }, { clock }) => {
	const safeVersion = version ?? clock.getVersion();
	const collection = query(collections).collection("memoEntities");
	collection.getOrCreate(id, (id) => createMemo({ id }));
	collection.replaceOperator(lww, safeVersion, id, POSITION_REGISTER, () => {
		collection.updateOne(id, (memo) => {
			memo.ui.x = x;
			memo.ui.y = y;
		});
	});
};
var removeMemoAction = createAction(ActionType.removeMemo);
var removeMemo = ({ doc, collections, lww }, { payload: { id }, version }, { clock }) => {
	const safeVersion = version ?? clock.getVersion();
	query(collections).collection("memoEntities").removeOperator(lww, safeVersion, id, () => {
		const index = doc.memoIds.indexOf(id);
		if (index !== -1) doc.memoIds.splice(index, 1);
	});
};
var changeMemoValueAction = createAction(ActionType.changeMemoValue);
var changeMemoValue = ({ collections, lww }, { payload: { id, value }, version }, { clock }) => {
	const safeVersion = version ?? clock.getVersion();
	const collection = query(collections).collection("memoEntities");
	collection.getOrCreate(id, (id) => createMemo({ id }));
	collection.replaceOperator(lww, safeVersion, id, "value", () => {
		collection.updateOne(id, (memo) => {
			memo.value = value;
		});
	});
};
var changeMemoColorAction = createAction(ActionType.changeMemoColor);
var changeMemoColor = ({ collections, lww }, { payload: { id, color }, version }, { clock }) => {
	const safeVersion = version ?? clock.getVersion();
	const collection = query(collections).collection("memoEntities");
	collection.getOrCreate(id, (id) => createMemo({ id }));
	collection.replaceOperator(lww, safeVersion, id, "ui.color", () => {
		collection.updateOne(id, (memo) => {
			memo.ui.color = color;
		});
	});
};
var resizeMemoAction = createAction(ActionType.resizeMemo);
var resizeMemo = ({ collections, lww }, { payload: { id, x, y, width, height }, version }, { clock }) => {
	const safeVersion = version ?? clock.getVersion();
	const collection = query(collections).collection("memoEntities");
	collection.getOrCreate(id, (id) => createMemo({ id }));
	collection.replaceOperator(lww, safeVersion, id, POSITION_REGISTER, () => {
		collection.updateOne(id, (memo) => {
			memo.ui.x = x;
			memo.ui.y = y;
		});
	}).replaceOperator(lww, safeVersion, id, SIZE_REGISTER, () => {
		collection.updateOne(id, (memo) => {
			memo.ui.width = width;
			memo.ui.height = height;
		});
	});
};
var changeZIndexAction = createAction(ActionType.changeZIndex);
var changeZIndex = ({ collections }, { payload: { id, zIndex } }) => {
	const collection = query(collections).collection("memoEntities");
	collection.getOrCreate(id, (id) => createMemo({ id }));
	collection.updateOne(id, (memo) => {
		memo.ui.zIndex = zIndex;
	});
};
var memoReducers = {
	[ActionType.addMemo]: addMemo,
	[ActionType.moveMemo]: moveMemo,
	[ActionType.moveToMemo]: moveToMemo,
	[ActionType.removeMemo]: removeMemo,
	[ActionType.changeMemoValue]: changeMemoValue,
	[ActionType.changeMemoColor]: changeMemoColor,
	[ActionType.resizeMemo]: resizeMemo,
	[ActionType.changeZIndex]: changeZIndex
};
var actions = {
	addMemoAction,
	moveMemoAction,
	moveToMemoAction,
	removeMemoAction,
	changeMemoValueAction,
	changeMemoColorAction,
	resizeMemoAction,
	changeZIndexAction
};
//#endregion
export { actions, addMemoAction, changeMemoColorAction, changeMemoValueAction, changeZIndexAction, memoReducers, moveMemoAction, moveToMemoAction, removeMemoAction, resizeMemoAction };
